import React, { useEffect, useState, useRef } from 'react';
import Form from 'react-bootstrap/Form';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import provinces from "@doncicuto/es-provinces";
import Boton from '../eventos/Boton';
import Accordion from 'react-bootstrap/Accordion';
import { ErrorForm } from '../eventos/Alerta';
import axios from 'axios';
import { handleChangeErrors, handleSubmitErrors, todosDatosCorrectos } from '../../validacion/ValidacionForm';
import { DatosCorrectos, PlazasAgotadas, ServerErrorEnvioForm, DatosIncorrectos } from '../eventos/VentanaEmergente';
import ReCAPTCHA from "react-google-recaptcha";
import { fetchCatcha, fetchCrearCurso } from '../../../peticiones_API/Penticiones_EnvioForm';
// const navigate = useNavigate();


//Formulario principal del curso
const FormCurso = ({ curso }) => {
    const recaptchaRef = useRef(null);
    const [captchaValue, setCaptchaValue] = useState('');
    const [submitRealizado, setSubmitRealizado] = useState(null);
    const [estadosActualizados, setEstadosActualizados] = useState(false);


    //Creo un array de objetos que guadará los datos obligatorios en todos los forumarios de los cursos
    const [formData, setFormData] = useState({
        nombre: '',
        correo: '',
        telefono: '',
        provincia: '',
        situacionLaboral: '',
        esFuncionario: '',
        comoNosConociste: '',
        aceptaPoliticaPrivacidad: '',

    });
    const [mensajeError, setMensajeError] = useState('');

    //Si los campos estan vacios en cualquiera de las categorias disponibles se le asiganará su mensaje de error correspondiente
    const camposRequeridos = {
        nombre: "Debes insertar un nombre",
        correo: "Debes insertar un correo",
        telefono: "Debes insertar un teléfono",
        provincia: "Debes seleccionar una provincia",
        situacionLaboral: "Debes seleccionar tu situación laboral",
        esFuncionario: "Debes seleccionar si eres funcionario",
        comoNosConociste: "Debes seleccionar cómo nos has conocido",
        aceptaPoliticaPrivacidad: "Debes aceptar la política de privacidad",
        DNIFrontal: "Debes adjuntar el DNI frontal",
        DNILateral: "Debes adjuntar el DNI trasero",
        informeVidaLaboral: "Debes adjuntar la vida laboral",
        anexo: "Debes adjuntar el anexo",
        renovacionEmpleo: "Debes adjuntar la renovación de la demanda de empleo",
        iAEconomicas: "Debes adjuntar el alta en el Impuesto de Actividades Económicas y el último recibo de autónomos",
        reciboAutonomos: "Debes adjuntar el recibo de autonomos",
        caNomina: "Debes adjuntar la nómina",
        funcionario: "Debes adjuntar el archivo justificativo de funcionario",
        tituloA: "Debes adjuntar tu titulo académico",
        captcha: "Debes completar el CAPTCHA"

    };



    //Controlaremos el estado de los alerts de los campos requeriods si esta el estado a true se activará la alerta correspondiente
    //Estos estados se complementan con los mensajes de error vistos anteriormente
    const [estadoCampoReque, setEstadoCampoReque] = useState({
        nombre: false,
        correo: false,
        telefono: false,
        provincia: false,
        situacionLaboral: false,
        esFuncionario: false,
        comoNosConociste: false,
        aceptaPoliticaPrivacidad: false,
        DNIFrontal: false,
        DNILateral: false,
        informeVidaLaboral: false,
        anexo: false,
        renovacionEmpleo: false,
        iAEconomicas: false,
        reciboAutonomos: false,
        caNomina: false,
        funcionario: false,
        tituloA: false,
        captcha: false
    });

    //Estos estados arán referencia a los casos en los que un dato seá sintacticamente erroneo 
    // Es decir, que un correo no cumpla con la estrutura de correo o un telefóno no se componga de 9 digitos
    const [estadoCampoSintaxis, setestadoCampoSintaxis] = useState({
        correoMal: false,
        telefonoMal: false
    });

    let [formCompletado, setFormCompletado] = useState(null);
    let [respuestaRespt, setRespuestaRespt] = useState(null);
    let [primerEnvio, setPrimerEnvio] = useState(false);

    const [captchaToken, setCaptchaToken] = useState(null);


    const handleChange = (event, nometoken = null) => {
        //if(submitRealizado) setSubmitRealizado(false);
        //Recogemos todos los eventos y carateritícas de todos los campos a rellenar
        //Los valores no definidos en los imports de defecto como los files se añadirán posteriormente como nuevo valor
        //En el caso de los checkbox al tener la propiedad checked tambien los trataremos de forma aislada
        //Segun vallamos rellenando el formulario los cambios se guadarán en el formdata

        if (nometoken == null && event?.target !== undefined && event?.target !== null) {
            setFormCompletado(null);
            const { name, value, type, files, checked } = event.target;
            const newValue = type === 'file' ? files[0] : (type === 'checkbox' ? checked : value);
            setFormData({ ...formData, [name]: newValue });

            if (name in estadoCampoReque) {
                handleChangeErrors(name, value, estadoCampoReque, estadoCampoSintaxis, setEstadoCampoReque, setestadoCampoSintaxis, setEstadosActualizados, primerEnvio);
            }

        }
        console.log("captchaToken ", nometoken);
        if (nometoken !== null) {
            setEstadoCampoReque(prevState => ({ ...prevState, captcha: false }));
        }

    };




    const handleSubmit = async (event) => {

        event.preventDefault();

        try {
            handleSubmitErrors(curso, camposRequeridos, formData, estadoCampoReque, estadoCampoSintaxis, setEstadoCampoReque, setestadoCampoSintaxis, setEstadosActualizados);
            if (captchaToken !== null) {
                setEstadoCampoReque(prevState => ({ ...prevState, captcha: false }));
                setEstadosActualizados(true);
            }
            else{
                setEstadosActualizados(false);
            }

            setPrimerEnvio(true);
            setSubmitRealizado(true);
        } catch (error) {
            setFormCompletado(false);
            setRespuestaRespt(false);
            setMensajeError(error.response.data.error);

        }

    };

    useEffect(() => {
        let validacionTodosDatos = todosDatosCorrectos(curso, formData, estadoCampoReque, estadoCampoSintaxis, setEstadoCampoReque);

        // Llama a la función todosCamposFalse dentro del validacionTodosDatos y guarda el validacionTodosDatos en otra variable

        let todosCamposFalse = validacionTodosDatos.todosCamposFalse();
        if (!todosCamposFalse) setSubmitRealizado(null);
        console.log("estadosActualizados",estadosActualizados);
        console.log("todosCamposFalse", todosCamposFalse);
        console.log("submitRealizado", submitRealizado);
        if (estadosActualizados && todosCamposFalse === true && submitRealizado === true) {
            console.log("Todos los campos son correctos");
            try {
                const onSubmitWithReCAPTCHA = async () => {
                    if (recaptchaRef.current) {
                        recaptchaRef.current.reset();
                    }

                    if (!captchaToken) {
                        setMensajeError("Por favor, completa el CAPTCHA.");
                        return;
                    }

                    const response = await fetchCatcha(captchaToken);

                    if (!response.data.success) {
                        setMensajeError("Validación de CAPTCHA fallida.");
                        setRespuestaRespt(false);
                        return;
                    }
                    if (captchaToken) {
                        const newData = { ...formData, curso: curso.nombre, plazasAgotadas: curso.plazasAgotadas };

                        // console.log("entro al condicional de todosCamposFalse");
                        const enviarCatcha = async (captchaToken) => {
                            // console.log("entro a enviarCatcha");
                            // console.log(captchaValue);

                            try {

                                if (response.data.success) {



                                    const enviarDatos = async (newData) => {
                                        try {
                                            const response = await fetchCrearCurso(newData);
                                            console.log(response.data);
                                            recaptchaRef.current.reset();
                                        } catch (error) {
                                            console.log("Error Datos");
                                            setFormCompletado(false);
                                            setRespuestaRespt(false);

                                            setMensajeError(error.response.data.error || 'Error desconocido del servidor');
                                            console.error('Error al enviar los datos:', error);

                                        }
                                    };
                                    enviarDatos(newData);
                                    setFormCompletado(null);



                                } else {
                                    console.log("error en el respon");
                                }
                            } catch (error) {
                                setFormCompletado(false);
                                setRespuestaRespt(false);
                                setMensajeError(error.response.data.error || 'Error desconocido del servidor');
                                console.error('Error al enviar los datos:', error);
                            }
                            recaptchaRef.current.reset();

                        }

                        enviarCatcha(captchaToken);
                        console.log("correo_enviado");
                        setFormCompletado(todosCamposFalse);
                        setRespuestaRespt(true);
                        if (formCompletado) {
                            const nuevoFormData = {};
                            for (const campo in formData) {
                                nuevoFormData[campo] = '';
                            }
                            setFormData(nuevoFormData);
                            window.history.back();
                        }

                        // console.log(formData);

                        const fileInputs = document.querySelectorAll('input[type="file"]');
                        fileInputs.forEach(input => {
                            input.value = "";
                        });
                        setMostrarAdjuntosLaboral(false);
                        setMostrarAdjuntosFuncionario(false);

                    } else {
                        console.log("No entro al token");
                    }
                    // apply to form data
                    // recaptchaRef.current.reset();
                }
                onSubmitWithReCAPTCHA();
            } catch (error) {
                setFormCompletado(false);
                setRespuestaRespt(false);
                setMensajeError(error.response.data.error || 'Error desconocido del servidor');
                console.error('Error al enviar los datos:', error);
            }
            setSubmitRealizado(null);

        }
    }, [estadosActualizados, formData, estadoCampoReque])

    //Estos dos useState personales se encargan de mostrar o ocultar los ficheros

    //requeridos a insertar dependiendo de que situación laboral se a selecionado
    const [situacionLaboral, setSituacionLaboral] = useState(formData.situacionLaboral || 0);
    const [mostrarAdjuntosLaboral, setMostrarAdjuntosLaboral] = useState(false);

    const handleSituacionLaboralChange = (event) => {
        const value = event.target.value;
        setSituacionLaboral(value);
        if (value !== 0) {
            setMostrarAdjuntosLaboral(true);
        } else {
            setMostrarAdjuntosLaboral(false);
        }
    };

    //Esta en vez de la situacion laboral, seria si es funcio se motraría la posibilidad
    //De insertar un fichero adjunto adicional
    const [funcionario, setFuncionario] = useState(0);
    const [mostrarAdjuntosFuncionario, setMostrarAdjuntosFuncionario] = useState(false);

    const handleFuncionarioChange = (event) => {
        const value = event.target.value;
        //console.log("funcionario",value);
        setFuncionario(value);
        if (value !== 0) {
            setMostrarAdjuntosFuncionario(true);
        } else {
            setMostrarAdjuntosFuncionario(false);
        }
    };


    //console.log("mostrarAdjuntosFuncionario",mostrarAdjuntosFuncionario);





    //console.log(curso);
    // console.log(formData);


    //console.log("plazasAgotadas",curso.plazasAgotadas);

    return (
        <>
            <DatosCorrectos envioActivado={formCompletado} respuesta={respuestaRespt} />

            <Form >
                <CabeceraForm>
                    {
                        curso.plazasAgotadas == null || curso.plazasAgotadas == 0 ?
                            <TituloForm>FORMULARIO <b>INSCRIPCIÓN</b></TituloForm>
                            :
                            <>
                                <PlazasAgotadas envioActivado={curso.plazasAgotadas} />
                                <TituloForm>FORMULARIO <b>LISTA ESPERA</b></TituloForm>
                            </>

                    }

                    <Rayita></Rayita>
                    {
                        //Si el curso no tiene subcategoria se motrará el anexo de la primera forma
                        //Y si sí la tiene se mostrará de la segunda forma
                    }
                    {
                        curso.subcategoriaId == null ?
                            <Anexo>
                                Para poder completar la inscripción al curso es necesario
                                copia del DNI / NIE (por las dos caras) y documentación
                                justificativa dependiendo de tu situación laboral.
                            </Anexo>
                            :
                            <Anexo>
                                Para poder completar la inscripción al curso es necesario
                                copia del DNI / NIE (por las dos caras), cumplimentar el
                                Anexo que puedes
                                <Link
                                    to={curso.anexo.startsWith('https') ? curso.anexo : `https://tuscursossepe.com/anexos/${curso.anexo}`}
                                    style={{ margin: '8px' }}
                                >
                                    descargarte aquí
                                </Link>
                                y documentación justificativa dependiendo de tu situación laboral.
                            </Anexo>

                    }


                </CabeceraForm>

                {
                    //Cada campo se compondrá del título, el campo a insertar con su onchange 
                    //que cambiará en base a lo insertado
                    //Y su alert correspondiente el cual por defecto estarán desactivados y se activarán
                    //En cuanto las funciones que detectan los errores detecten algún error
                }

                <Form.Group className="mb-3" controlId="formBasicNameSurname">
                    <TituloCategoria>Nombre y apellidos <span>*</span></TituloCategoria>
                    <Form.Control type="name" name="nombre" value={formData.nombre || ''} onChange={handleChange} />
                    <ErrorForm mensaje={camposRequeridos.nombre} estadoAlerta={estadoCampoReque.nombre} />
                </Form.Group>

                <Form.Group className="mb-3" controlId="formBasicEmail">
                    <TituloCategoria>E-mail <span>*</span></TituloCategoria>
                    <Form.Control type="email" name="correo" value={formData.correo || ''} onChange={handleChange} />
                    <ErrorForm mensaje={camposRequeridos.correo} estadoAlerta={estadoCampoReque.correo} />
                    <ErrorForm mensaje="Correo erroneo" estadoAlerta={estadoCampoSintaxis.correoMal} />

                </Form.Group>

                <Form.Group className="mb-3" controlId="formBasicPhone">
                    <TituloCategoria>Telefono <span>*</span></TituloCategoria>
                    <Form.Control type="phone" name="telefono" value={formData.telefono || ''} onChange={handleChange} />
                    <ErrorForm mensaje={camposRequeridos.telefono} estadoAlerta={estadoCampoReque.telefono} />
                    <ErrorForm mensaje="Telefono erroneo" estadoAlerta={estadoCampoSintaxis.telefonoMal} />
                </Form.Group>

                {
                    //Para el listado de provicias descargue la libería doncicuto que me proporciona el listado de provicias
                }
                <Form.Group className="mb-3">
                    <TituloCategoria>
                        Provincia <span>*</span>
                    </TituloCategoria>
                    <Form.Select value={formData.provincia || ''} name="provincia" onChange={handleChange}>
                        <option value="" disabled></option>
                        {provinces
                            .slice()
                            .sort((a, b) => a.name.localeCompare(b.name))
                            .map((provincia, index) => (
                                <option key={index}>{provincia.name}</option>
                            ))}
                    </Form.Select>
                    <ErrorForm mensaje={camposRequeridos.provincia} estadoAlerta={estadoCampoReque.provincia} />
                </Form.Group>


                {
                    //El handleSituacionLaboralChange y handleFuncionarioChange registrán la opcion selecionada
                    //para mostrar los ficheros adjuntos correspondientes
                }
                <Form.Group className="mb-3">
                    <TituloCategoria id="situacionLaboral" >Situación laboral <span>*</span></TituloCategoria>
                    <Form.Select value={formData.situacionLaboral || ''} name="situacionLaboral" onChange={(e) => { handleChange(e); handleSituacionLaboralChange(e); }}>
                        <option value="0"></option>
                        <option value="Desempleado">Desempleado</option>
                        <option value="Trabajador en activo">Trabajador en activo</option>
                        <option value="Erte">Erte</option>
                        <option value="Autónomo">Autónomo</option>
                    </Form.Select>
                    <ErrorForm mensaje={camposRequeridos.situacionLaboral} estadoAlerta={estadoCampoReque.situacionLaboral} />
                </Form.Group>

                <Form.Group className="mb-3">
                    <TituloCategoria id="administracion">¿Funcionario o trabajador que presta sus servicios
                        en una administración pública? <span>*</span></TituloCategoria>
                    <Form.Select value={formData.esFuncionario || ''} name="esFuncionario" onChange={(e) => { handleChange(e); handleFuncionarioChange(e); }}>
                        <option value="0"></option>
                        <option value="Si">Sí</option>
                        <option value="No">No</option>
                    </Form.Select>
                    <ErrorForm mensaje={camposRequeridos.esFuncionario} estadoAlerta={estadoCampoReque.esFuncionario} />
                </Form.Group>

                <Form.Group className="mb-3">
                    <TituloCategoria>¿Cómo nos has conocido? <span>*</span></TituloCategoria>
                    <Form.Select value={formData.comoNosConociste || ''} name="comoNosConociste" onChange={handleChange}>
                        <option></option>
                        <option value="Google">Google</option>
                        <option value="Facebook">Facebook</option>
                        <option value="Instagram">Instagram</option>
                        <option value="Newsletter">Newsletter</option>
                        <option value="conocidos">Mediante conocidos, compañeros…</option>
                        <option value="Otros">Otros</option>
                    </Form.Select>
                    <ErrorForm mensaje={camposRequeridos.comoNosConociste} estadoAlerta={estadoCampoReque.comoNosConociste} />
                </Form.Group>

                <Form.Group className="mb-3" controlId="formBasicCheckbox">
                    <Form.Check type="checkbox" >
                        <Form.Check.Input id="checkbox" name="aceptaPoliticaPrivacidad" checked={formData.aceptaPoliticaPrivacidad || ''} onChange={handleChange} />
                        <TituloCheckBox>
                            Acepto y he leído la{" "}
                            <Link to="/politica-de-privacidad" target="_blank" rel="noopener noreferrer">
                                Política de Privacidad
                            </Link>{" "}
                            <span>*</span>
                        </TituloCheckBox>

                    </Form.Check>
                    <ErrorForm mensaje={camposRequeridos.aceptaPoliticaPrivacidad} estadoAlerta={estadoCampoReque.aceptaPoliticaPrivacidad} />
                </Form.Group>


                {mostrarAdjuntosLaboral && (


                    <>
                        {
                            //Si tiene alguna subcategoria se mostrará la posibilidad de importar este archivo


                        }
                        {curso?.SubCategorium?.length != 0 ? (
                            <Form.Group controlId="anexoFile" className="mb-3">
                                <TituloCategoria>Adjuntar anexo (max 3MB)</TituloCategoria>
                                <Form.Text className="text-muted">
                                    <br />El anexo solo será válido si está firmado
                                    con firma digital o certificado electrónico, o en
                                    su defecto debe imprimirse y firmarse a mano y
                                    escanearlo o sacarle una foto para adjuntarlo.
                                </Form.Text>
                                <Form.Control type="file" accept=".jpg,.jpeg,.png,.gif,.pdf,.doc,.docx,.ppt,.pptx,.odt" max-file-size="3072"
                                    name="anexo" onChange={handleChange} />
                                <ErrorForm mensaje={camposRequeridos.anexo} estadoAlerta={estadoCampoReque.anexo} />
                            </Form.Group>
                        ) : (
                            <></>
                        )}

                        <Form.Group controlId="DNIFrontalFile" className="mb-3">
                            <TituloCategoria>Adjuntar DNI por la cara frontal (max 3MB)</TituloCategoria>
                            <Form.Control type="file" accept=".jpg,.jpeg,.png,.gif,.pdf,.doc,.docx,.ppt,.pptx,.odt" max-file-size="3072"
                                name="DNIFrontal" onChange={handleChange} />
                            <ErrorForm mensaje={camposRequeridos.DNIFrontal} estadoAlerta={estadoCampoReque.DNIFrontal} />
                        </Form.Group>

                        <Form.Group controlId="DNILateralFile" className="mb-3">
                            <TituloCategoria>Adjuntar DNI por la cara trasera (max 3MB)</TituloCategoria>
                            <Form.Control type="file" accept=".jpg,.jpeg,.png,.gif,.pdf,.doc,.docx,.ppt,.pptx,.odt" max-file-size="3072"
                                name="DNILateral" onChange={handleChange} />
                            <ErrorForm mensaje={camposRequeridos.DNILateral} estadoAlerta={estadoCampoReque.DNILateral} />
                        </Form.Group>

                        {(() => {
                            //console.log(situacionLaboral);
                            //Según la situación laboral se motrarán la posibilidad de adjuntar unos archivos u otros

                            switch (situacionLaboral) {
                                case "Desempleado":
                                    return (
                                        <Form.Group controlId="renovacionEmpleoFile" className="mb-3">
                                            <TituloCategoria>Adjuntar la renovación de la demanda de empleo (max 3MB)</TituloCategoria>
                                            <Form.Control type="file" accept=".jpg,.jpeg,.png,.gif,.pdf,.doc,.docx,.ppt,.pptx,.odt" max-file-size="3072"
                                                name="renovacionEmpleo" onChange={handleChange} />
                                            <ErrorForm mensaje={camposRequeridos.renovacionEmpleo} estadoAlerta={estadoCampoReque.renovacionEmpleo} />
                                        </Form.Group>
                                    );
                                case "Trabajador en activo":
                                    return (
                                        <Form.Group controlId="caNominaFile" className="mb-3">
                                            <TituloCategoria>Adjuntar la cabecera de la última nómina (max 3MB)</TituloCategoria>
                                            <Form.Control type="file" accept=".jpg,.jpeg,.png,.gif,.pdf,.doc,.docx,.ppt,.pptx,.odt" max-file-size="3072"
                                                name="caNomina" onChange={handleChange} />
                                            <ErrorForm mensaje={camposRequeridos.caNomina} estadoAlerta={estadoCampoReque.caNomina} />
                                        </Form.Group>
                                    );
                                case "Erte":
                                    return (
                                        <></>
                                    );
                                case "Autónomo":
                                    return (
                                        <>
                                            <Form.Group controlId="iAEconomicasFile" className="mb-3">
                                                <TituloCategoria>Adjuntar alta en el Impuesto de Actividades Económicas (IAE) (max 3MB)</TituloCategoria>
                                                <Form.Control type="file" accept=".jpg,.jpeg,.png,.gif,.pdf,.doc,.docx,.ppt,.pptx,.odt" max-file-size="3072"
                                                    name="iAEconomicas" onChange={handleChange} />
                                                <ErrorForm mensaje={camposRequeridos.iAEconomicas} estadoAlerta={estadoCampoReque.iAEconomicas} />
                                            </Form.Group>

                                            <Form.Group controlId="reciboAutonomosFile" className="mb-3">
                                                <TituloCategoria>Adjuntar último recibo de autónomos (max 3MB)</TituloCategoria>
                                                <Form.Control type="file" accept=".jpg,.jpeg,.png,.gif,.pdf,.doc,.docx,.ppt,.pptx,.odt" max-file-size="3072"
                                                    name="reciboAutonomos" onChange={handleChange} />
                                                <ErrorForm mensaje={camposRequeridos.caNomina} estadoAlerta={estadoCampoReque.caNomina} />
                                            </Form.Group>
                                        </>

                                    );
                                default:
                                    return null;
                            }
                        })()}



                        <Form.Group controlId="vidaLaboralFile" className="mb-3">
                            <TituloCategoria>Adjuntar informe de vida laboral (max 3MB)</TituloCategoria>
                            <Form.Control type="file" accept=".jpg,.jpeg,.png,.gif,.pdf,.doc,.docx,.ppt,.pptx,.odt" max-file-size="3072"
                                name="informeVidaLaboral" onChange={handleChange} />
                            <ErrorForm mensaje={camposRequeridos.informeVidaLaboral} estadoAlerta={estadoCampoReque.informeVidaLaboral} />
                        </Form.Group>


                    </>
                )}


                {
                    //Si se activado adjuntosFuncionario si la ocion está en si, veremos la posibilidad de adjuntar un archivo adicional
                }
                {mostrarAdjuntosFuncionario && (

                    <>
                        {(() => {
                            //console.log("funcionario",funcionario);
                            switch (formData.esFuncionario) {
                                case "Si":
                                    return (
                                        <Form.Group controlId="formFile" className="mb-3">
                                            <TituloCategoria>Adjuntar Documento de Escrito justificativo de funcionarios y trabajadores que
                                                prestan sus servicios en administraciones públicas (max 3MB)</TituloCategoria>
                                            <Form.Control type="file" accept=".jpg,.jpeg,.png,.gif,.pdf,.doc,.docx,.ppt,.pptx,.odt" max-file-size="3072"
                                                name="funcionario" onChange={handleChange} />
                                            <ErrorForm mensaje={camposRequeridos.funcionario} estadoAlerta={estadoCampoReque.funcionario} />
                                        </Form.Group>
                                    );

                                case "No":
                                    <></>
                                    break;

                                default:
                                    break;
                            }
                        })()}
                    </>
                )}

                {
                    //Si tiene algún requisito se mostrará la posibilidad de adjuntar este archivo
                }

                <Form.Group controlId="tituloAFile" className="mb-3">
                    <TituloCategoria>Adjuntar Documento de título académico (max 3MB)</TituloCategoria>
                    <Form.Control type="file" accept=".jpg,.jpeg,.png,.gif,.pdf,.doc,.docx,.ppt,.pptx,.odt" max-file-size="3072"
                        name="tituloA" onChange={handleChange} />
                    <ErrorForm mensaje={camposRequeridos.tituloA} estadoAlerta={estadoCampoReque.tituloA} />
                </Form.Group>


                {
                    //Al selecionar cualquier opcion de situacion laboral se activara esta condición 
                    //y los adjuntos por defecto en cualquier opción
                }


                <ReCAPTCHA
                    sitekey="6LduzrYpAAAAAHZvATEFxjivMSRYdZolVmuAI6Dq"
                    ref={recaptchaRef}
                    size="normal"
                    onChange={(token) => {
                        setCaptchaToken(token);
                        handleChange(null, token);
                    }}
                />
                <ErrorForm mensaje={camposRequeridos.captcha} estadoAlerta={estadoCampoReque.captcha} />


                <Boton as="button" primario="true" type="submit" onClick={handleSubmit} form="true" >Enviar</Boton>
            </Form >
            <DatosIncorrectos envioActivado={formCompletado} />
            <ServerErrorEnvioForm envioActivado={formCompletado} mensajeError={mensajeError} />
            <AcordeonProDatos>

                <CabezeraAcordeon><p>Información sobre protección de datos</p>

                </CabezeraAcordeon >
                <CuerpoAcordeon>
                    <p><strong><em>INFORMACIÓN BÁSICA DE PROTECCIÓN DE DATOS</em></strong><em>:&nbsp;En cumplimiento del deber de informar a los interesados de las circunstancias y condiciones del tratamiento de sus datos y de los derechos que le asisten, ponemos a su disposición la siguiente información. </em></p>
                    <p><strong><em>RESPONSABLE DE TRATAMIENTO</em></strong><em>: LAE Formación Programada, S.L.</em></p>
                    <p><strong><em>FINALIDAD DEL TRATAMIENTO DE SUS DATOS</em></strong><em>:&nbsp;Incluir su candidatura en futuros procesos de selección de la empresa. </em></p>
                    <p><strong><em>CONTACTO DEL DELEGADO DE PROTECCIÓN DE DATOS:</em></strong> <Link to="mailto:dpo@grupolae.net">dpo@grupolae.net</Link></p>
                    <p><strong><em>CONSERVACIÓN DE LOS DATOS:</em></strong><em> Los datos se conservarán durante un plazo de 6 meses desde la recepción del curriculum. Agotado este plazo la empresa destruirá el curriculum al menos que el candidato haya mandado una actualización del mismo.</em></p>
                    <p><strong><em>LEGITIMACIÓN PARA EL TRATAMIENTO</em></strong><em>:&nbsp;Consentimiento explícito otorgado con la aceptación de las condiciones de uso de nuestro formulario.</em></p>
                    <p><strong><em>DESTINATARIOS DE SUS DATOS PERSONALES</em></strong><em>:&nbsp;No se prevén cesiones de datos salvo en aquellos casos en que exista una obligación legal. No hay previsión de transferencias de datos internacionales. En caso de que la empresa envíe su curriculum a un tercero se solicitará formalmente su conformidad.</em></p>
                    <p><strong><em>SUS DERECHOS</em></strong><em>: Puede revocar el consentimiento y ejercer sus Derechos a acceder, rectificar, oponerse, limitar, portar y suprimir los datos, escribiendo a LAE Formación Programada, S.L., en C/ Juan F. Gilisagasti 2 – Oficina 215, 20018 Donostia – San Sebastián (Gipuzkoa), además de la posibilidad de acudir a la autoridad de control competente (AEPD).</em></p>
                    <p><strong><em>INFORMACIÓN ADICIONAL</em></strong><em>:</em> <em>Puede consultar la información adicional y detallada en nuestra <Link to="/politica-de-privacidad" target="_blank" rel="noopener">Política de Privacidad</Link>.</em></p>

                </CuerpoAcordeon>

            </AcordeonProDatos>

        </>
    );
}


const CabeceraForm = styled.div`
    margin-bottom: 10px;
`

const TituloForm = styled.h3`
    color: #000000;
    font-family: "Dosis";
    font-size: 22px;
    font-weight: 400;
    text-transform: uppercase;
    text-align: center;

`

const Rayita = styled.span`
    margin-top: 8% !important;
    margin-bottom: 8% !important;
    width: 31% ;
    margin: 0 auto ;
    border: solid #EE805D;
    display: block;
`

const Anexo = styled.p`
    color: #7A7A7A;
    margin: 0 0 20px;
    font-family: 'Roboto';
    a{
        color:black;
    }

`

const TituloCategoria = styled(Form.Label)`
    font-weight: bold;
    font-family: 'Open Sans';
    font-size: 15.6px;
    line-height: 1.8;
    color: #4a4a4a;

    span{
        color: #ff0000;
        font-weight: 400;
    }

`
const TituloCheckBox = styled(Form.Check.Label)`
    margin-left: 10px;
    
    a{
        text-decoration: none;
        font-weight: bold;
        font-size: 16px;
        color: #333333;
    }

    a:hover{
        color: #337ab7;
    }

    span{
         color: #ff0000;
        font-weight: 400;
    }
`

const AcordeonProDatos = styled(Accordion)`
    .accordion-button:focus {
    border-color:  rgba(0, 0, 0, 0) !important;
    
    box-shadow:  rgba(0, 0, 0, 0) !important;
    }

    .accordion-button:not(.collapsed) {
    color: rgba(0, 0, 0, 0);
    background-color: rgba(0, 0, 0, 0);
    box-shadow: inset 0 calc(-1* var(--bs-accordion-border-width)) 0 rgba(0, 0, 0, 0);
    }

    
`

const HeaderAcordion = styled(Accordion.Header)`
    p{
        margin-top: 3%;
        margin-right: 15%;
        font-size: 14px;
        color: #EE805D;
    }
    
    
    .accordion-button:not(.collapsed)::before {
    
    transform: rotate(90deg);
    
    }
    .accordion-button::before {
        
    width: var(--bs-accordion-btn-icon-width);
    height: var(--bs-accordion-btn-icon-width);
    margin-right: auto;
    content: "";
    
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='rgb(238, 128, 93)' class='bi bi-caret-right-fill' viewBox='0 0 16 16'%3E%3Cpath d='m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-size: 15px;
    transition: var(--bs-accordion-btn-icon-transition);
    }

    .accordion-button::after {
    display: none;
    }


`
const CabezeraAcordeon = styled(HeaderAcordion)`
    p{
        margin-right: 30% !important;
    }

    @media (max-width: 1250px) {
        p{
        margin-right: 50% !important;
    }
    }
    
`

const CuerpoAcordeon = styled(Accordion.Body)`
color: #7A7A7A;
font-family: 'Roboto';
    a{
        text-decoration: none;
        color: black;
    }
`

export default FormCurso;